import type { SpreadReadingProfile } from "../types";

export const situationDevelopmentReadingProfile: SpreadReadingProfile = {
  spreadId: "spread_situation_development",
  sections: [
    {
      id: "mainMeaning",
      title: "Основной смысл",
      source: { type: "keywords" },
    },
    {
      id: "questionContext",
      title: "В контексте вопроса",
      source: { type: "uprightByQuestionContext" },
    },
    {
      id: "psychology",
      title: "Психологический аспект",
      source: { type: "psychology" },
    },
  ],
};

